import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageView } from './analytics';

/**
 * Reports a GA page view on every route change. Renders nothing, and is a no-op
 * when analytics is off. Must sit inside the router.
 */
export function AnalyticsPageTracker(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
}
